import SelectedValue from "@components/request-access/SelectedValue";
import { PeekListItemText, PeekMenuItem, PeekSelect, PeekStack, useTheme } from "@piiqtechnologies/ui-components";
import React, { useMemo, useState } from "react";
import { useIntl } from "react-intl";
import messages from "./messages.i18n";
import { Funnel } from "@piiqtechnologies/svg-icons";
const SELECT_ALL_OPTION = "all";
const CLEAR_SELECTION_OPTION = "clear";
const MultipleOrganizationSelector = ({ organizations, selectedOrganizations, onSelectionChange, placeholder, }) => {
    const intl = useIntl();
    const theme = useTheme();
    const [openSelectCommunities, setOpenSelectCommunities] = useState(false);
    const toggleSelectCommunities = () => {
        setOpenSelectCommunities(!openSelectCommunities);
    };
    const handleSelectCommunity = (event) => {
        if (event.target.value.includes(SELECT_ALL_OPTION)) {
            const communitiesSelected = !event.target.value.includes(SELECT_ALL_OPTION) && event.target.value;
            onSelectionChange(communitiesSelected);
        }
        else if (event.target.value.includes(CLEAR_SELECTION_OPTION)) {
            onSelectionChange([]);
        }
        else {
            onSelectionChange(event.target.value);
        }
    };
    const removeSelectedCommunity = (propertyId) => {
        onSelectionChange(selectedOrganizations.filter((propId) => propId !== propertyId));
    };
    const SelectUnselectAllOption = useMemo(() => {
        const isAllSelected = (organizations === null || organizations === void 0 ? void 0 : organizations.length) === (selectedOrganizations === null || selectedOrganizations === void 0 ? void 0 : selectedOrganizations.length);
        return (React.createElement(PeekMenuItem, { key: isAllSelected ? CLEAR_SELECTION_OPTION : SELECT_ALL_OPTION, value: isAllSelected ? CLEAR_SELECTION_OPTION : SELECT_ALL_OPTION, "aria-label": isAllSelected ? "Clear selection" : "Select All Communities", hoverBgColor: "info", selectedBgColor: "info" },
            React.createElement(PeekListItemText, null, !!isAllSelected ? intl.formatMessage(messages.clearSelection) : intl.formatMessage(messages.selectAll))));
    }, [organizations, selectedOrganizations]);
    //@ts-ignore
    return (React.createElement(PeekSelect, { key: "_id", value: selectedOrganizations, onChange: handleSelectCommunity, inputProps: { "aria-label": "Your Organizations" }, IconComponent: () => null, showBorder: true, displayEmpty: true, multiple: true, renderValue: (selected) => {
            return (React.createElement(PeekStack, { direction: "row", alignItems: "center", spacing: 0.5 },
                React.createElement(Funnel, { fontSize: 18, color: theme.palette.grey[400] }),
                React.createElement(SelectedValue, { toggleSelectProperties: toggleSelectCommunities, removeSelected: removeSelectedCommunity, selected: selected, values: organizations, placeholder: placeholder || intl.formatMessage(messages.selectOrganizationPlaceholder) })));
        }, open: openSelectCommunities, onClose: toggleSelectCommunities, MenuProps: {
            disablePortal: true,
        }, sx: {
            minWidth: theme.spacing(25),
            height: theme.spacing(4.2),
            minHeight: "fit-content",
            backgroundColor: "common.white",
        } },
        SelectUnselectAllOption, organizations === null || organizations === void 0 ? void 0 :
        organizations.map((organization) => {
            return (React.createElement(PeekMenuItem, { key: organization._id, value: organization._id, "aria-label": organization.name, hoverBgColor: "info", selectedBgColor: "info" },
                React.createElement(PeekListItemText, { primaryTypographyProps: {
                        fontWeight: selectedOrganizations.includes(organization._id) ? "fontWeightBold" : "fontWeightRegular",
                    } }, organization.name)));
        })));
};
export default MultipleOrganizationSelector;
